import React from 'react';
import Loading from '../../loadings';
import $ from "jquery";
import Server from '../../../functions/server';
import { Input, Button } from 'semantic-ui-react';
import Checkbox from '@material-ui/core/Checkbox';

class Executive extends React.Component {

  state = {
    data: []
  }

  componentDidMount() {
    this.getExecutive();
  }

  getExecutive() {
    let context = this;
    context.setState({ load: true, message: 'Get all Executive!!!' })
    $.ajax({
      type: 'POST',
      url: Server() + 'settings/getexecutive.php',
      success: function(data)
      {
        context.setState({ load: false })
        try {
          data = JSON.parse(data);
          context.setState({ data: data })
        } catch (e) {
          alert('Error')
        }
        console.log(data);
      },
      error: function(err)
      {
        console.log(err);
        alert('Try Again!!!')
        context.setState({
          load: false,
        })
      }
    })
  }

  textHandle = (id, type) => event => {
    let data = this.state.data;
    let value = event.target.value;
    if (value < 0) {
      alert('Value is negative!!!');
      return;
    }
    else {
      if (value > 100) {
        alert('Value is greater Then 100!!!');
        return;
      }
      else {
        data.map((d) => {
          if (d.id == id) {
            if (type == 'executivecreationpoints') {
              d.executivecreationpoints = event.target.value;
            }
            else {
              d.selfcreationpoints = event.target.value;
            }
          }
        })
        this.setState({ data: data })
      }
    }
  }

  submit() {
    let context = this;
    let array = this.state.data;
    array.map((c) => {
      if (c.executivecreationpoints == '' || c.executivecreationpoints == null) {
        c.executivecreationpoints = 0;
      }
      if (c.selfcreationpoints == '' || c.selfcreationpoints == null) {
        c.selfcreationpoints = 0;
      }
    })
    array = JSON.stringify(array);
    context.setState({ load: true, message: 'Submitting points!!!' })
    $.ajax({
      type: 'POST',
      data: { 'pointsarray': array },
      url: Server() + 'settings/insertpoints.php',
      success: function(data)
      {
        context.setState({ load: false });
        if (data == 1) {
          alert('Points Updated Successfully!!!');
        }
      },
      error: function(err)
      {
        alert('Try Again!!!')
        context.setState({
          load: false,
        })
      }
    })
  }

  handleChange1 = (type, id) => event => {
    let data = this.state.data;
    let value = 0;
    if (event.target.checked == true) {
      value = 1;
    }
    if (type == 'app') {
      data.map((d) => {
        if (d.id == id) {
          d.app = value;
        }
      })
    }
    else {
      data.map((d) => {
        if (d.id == id) {
          d.web = value;
        }
      })
    }
    this.setState({ data: data })
  }

  render() {
    let i = 1;
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <div style={{padding: '2%'}}>
          <table id='table' width='100%'>
            <tr>
              <th style={{width: '10%'}} id='th'><center>Id</center></th>
              <th style={{width: '30%'}} id='th'><center>Executive</center></th>
              <th style={{width: '30%'}} id='th'><center>Self Created Points</center></th>
              <th style={{width: '30%'}} id='th'><center>Executive Creation Points</center></th>
            </tr>
            { this.state.data.map((c) => {
                let app = false;
                let web = false;
                if (c.app == 1) {
                  app = true;
                }
                if (c.web == 1) {
                  web = true;
                }
                let selfcreationpoints;
                let executivecreationpoints;
                try {
                  selfcreationpoints = Number(c.selfcreationpoints);
                  executivecreationpoints = Number(c.executivecreationpoints);
                } catch (e) {
                }
                return (
                  <tr id='tbody'>
                    <td><center>{i++}</center></td>
                    <td>{c.id+'->'+c.name}</td>
                    <td><center><Input type='number' value={selfcreationpoints} fluid onChange={this.textHandle(c.id, 'selfcreationpoints')} /></center></td>
                    <td>
                      <center style={{display: 'flex'}}>
                        <Input type='number' value={executivecreationpoints}
                          onChange={this.textHandle(c.id, 'executivecreationpoints')} />
                          <div style={{display: 'flex'}}>
                            <div style={{paddingLeft: '12%'}}><br/>App:</div>
                            <Checkbox
                              checked={app}
                              onChange={this.handleChange1('app', c.id)}
                              value="check"
                            />
                          </div>
                          <div style={{display: 'flex'}}>
                            <div><br/>Web:</div>
                            <Checkbox
                              checked={web}
                              onChange={this.handleChange1('web', c.id)}
                              value="check"
                            />
                          </div>
                      </center>
                    </td>
                  </tr>
                )
              })
            }
          </table><br/>
          <center><Button primary onClick={this.submit.bind(this)}>SAVE</Button></center>
        </div>
      </div>
    );
  }
}

export default Executive;
